import { Component, OnDestroy, OnInit } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { Subscription } from 'rxjs';
import { ConnectorService } from 'src/app/state';

@Component({
  selector: 'em-connector',
  templateUrl: './connector.component.html',
  standalone: false,
})
export class ConnectorComponent implements OnInit, OnDestroy {
  public connectors$ = this.connectorService.connectors$;
  public isLoading$ = this.connectorService.loading$;
  public error$ = this.connectorService.error$;
  public readonly trackByRef = trackByRef;

  private readonly subscriptions = new Subscription();

  public constructor(private readonly connectorService: ConnectorService) {}

  public ngOnInit(): void {
    this.subscriptions.add(this.connectorService.loadBySuperDesign().subscribe());
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
